import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './../material-module';
import { MarvelChampionsComponent } from './marvel-champions.component';
import { MarvelChampionsRoutingModule } from './marvel-champions-routing.module';
import { SharedModule } from './../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BoardGameComponent } from './views/board-game/board-game.component';
import { RoomService } from '../shared/services/room.service';
import { RoomSelectComponent } from './views/room-select/room-select.component';
import { RoomCreationComponent } from './views/room-creation/room-creation.component';
import { AboutComponent } from './views/about/about.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MarvelChampionsRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule
  ],
  declarations: [
    MarvelChampionsComponent,
    BoardGameComponent,
    RoomSelectComponent,
    RoomCreationComponent,
    AboutComponent
  ],
  providers: [RoomService],
  exports: [
    // OptionsComponent
  ]
})
export class MarvelChampionsModule {}
